import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronRightIcon } from '@calendly/ui/components/icons';
import { Sheet } from '@calendly/ui/components/sheet';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { toggleContactDrawerOpen, setCurrentContact } from '../slice';
import { EmptyNextMeetingHistory } from './empty_next_meeting_history';
const cardCss = "c1f4ehq1";
const Card = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardCss, props.className)} />;
});
const styledSheetCss = "syxst4i";
const StyledSheet = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(styledSheetCss, props.className)} />);
const sectionHeaderCss = "scsgr7f";
const SectionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionHeaderCss, props.className)} />;
});
const capCss = "c1xu294p";
const Cap = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(capCss, props.className)} />;
});
const containerCss = "c1ibq0um";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const iconContainerCss = "i17m19mu";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const detailsContainerCss = "dwwx3vd";
const DetailsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(detailsContainerCss, props.className)} />;
});
const styledButtonCss = "s18odi20";
const StyledButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
const NextMeeting = ({
  meeting,
  onHandleClick
}) => {
  const dispatch = useDispatch();
  const isPhone = useDeviceType('isPhone');
  const onClose = () => {
    onHandleClick();
    if (isPhone) {
      dispatch(toggleContactDrawerOpen());
      dispatch(setCurrentContact(null));
    }
  };
  return <StyledButton onClick={onClose}>
      <StyledSheet>
        <Cap color={meeting.eventTypeColor} />
        <Card>
          <DetailsContainer>
            <BodyText weight="bold">{meeting.name}</BodyText>
            <BodyText color="muted" size="medium">
              {`${meeting.dateShorthand ?? meeting.date}, ${meeting.startTime}-${meeting.endTime}`}
            </BodyText>
            <BodyText color="muted" size="medium">{meeting.location || ' '}</BodyText>
          </DetailsContainer>
          <IconContainer>
            <ArrowChevronRightIcon />
          </IconContainer>
        </Card>
      </StyledSheet>
    </StyledButton>;
};
export const NextMeetingHistory = ({
  nextMeeting,
  onHandleClick
}) => {
  if (!nextMeeting) {
    return <EmptyNextMeetingHistory />;
  }
  return <>
      <SectionHeader>
        <BodyText size="medium" color="muted" weight="bold">{I18n.t('publisher.contacts.profile.next_meeting')}</BodyText>
      </SectionHeader>
      <Container>
        <NextMeeting onHandleClick={onHandleClick} meeting={nextMeeting} />
      </Container>
    </>;
};

require("./next_meeting.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./next_meeting.js");